import { Link } from "react-router-dom";

const LINKS = [
  { to: "/legal/terms", label: "Terms & Conditions" },
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/aup", label: "Acceptable Use Policy" },
  { to: "/legal/agreement", label: "Store Owner Agreement" },
];

export function LegalLinks({ className = "", light = false }) {
  return (
    <nav className={`flex flex-wrap gap-x-5 gap-y-2 ${className}`} data-testid="legal-links">
      {LINKS.map((l) => (
        <Link key={l.to} to={l.to} className={`text-sm hover:underline ${light ? "text-white/70 hover:text-white" : "text-muted-foreground hover:text-foreground"}`} data-testid={`legal-link-${l.to.split("/").pop()}`}>
          {l.label}
        </Link>
      ))}
    </nav>
  );
}
